import Cookies from 'js-cookie';
// eslint-disable-next-line import/no-cycle
const token = Cookies.get('SID');
const customerToken = Cookies.get('SID_CLIENT');
const withBearer = `Bearer ${token}`;
const customerWithBearer = `Bearer ${customerToken}`;

export { withBearer, customerWithBearer, customerToken };
export default token;
